module.exports = __webpack_public_path__ + "static/media/Logo.b929b7df.png";